import UserAdminAccount from "./UserAdminAccount-container";

/**
 * Export the top level component UserAdminAccount-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default UserAdminAccount;
